import apiCall from "../AuthorizedApi";
import {
  StorageAddonOrder,
  StorageAddonPricingResponse,
  StorageAddonPurchase,
  StorageAddonQuote,
} from "../../../Data/storageAddon.dto";

const BASE = "/plans/storage-addons";

export const getApiErrorMessage = (error: any, fallback: string): string => {
  const data = error?.response?.data;
  return (
    data?.message ||
    data?.detail ||
    data?.error?.message ||
    (typeof data?.error === "string" ? data.error : null) ||
    error?.message ||
    fallback
  );
};

const unwrap = <T>(res: any): T => (res?.data !== undefined ? res.data : res);

export const getStorageAddonPricing = async (): Promise<StorageAddonPricingResponse> => {
  const res = await apiCall({ method: "GET", url: `${BASE}/` });
  return unwrap<StorageAddonPricingResponse>(res);
};

export const quoteStorageAddon = async (storage_gb: number): Promise<StorageAddonQuote> => {
  const res = await apiCall({
    method: "POST",
    url: `${BASE}/quote/`,
    data: { storage_gb },
  });
  return unwrap<StorageAddonQuote>(res);
};

export const createStorageAddonOrder = async (params: {
  storage_gb: number;
  return_url?: string;
}): Promise<StorageAddonOrder> => {
  const res = await apiCall({
    method: "POST",
    url: `${BASE}/create-order/`,
    data: params,
  });
  return unwrap<StorageAddonOrder>(res);
};

export const verifyStorageAddonOrder = async (order_id: string): Promise<any> => {
  const res = await apiCall({
    method: "POST",
    url: `${BASE}/verify/`,
    data: { order_id },
  });
  return unwrap(res);
};

export const getStorageAddonPurchases = async (params?: {
  page?: number;
  page_size?: number;
}): Promise<StorageAddonPurchase[]> => {
  const res = await apiCall({
    method: "GET",
    url: `${BASE}/purchases/`,
    params,
  });
  const data = unwrap<any>(res);
  const list = data?.results ?? data?.purchases ?? data;
  return Array.isArray(list) ? list : [];
};
